import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";

/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-03 11:34:54
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-04-14 14:27:33
 * @Description: file content
 */
import React, { useMemo } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

var genFullPath = function genFullPath(path, name) {
  if (name === 'index') {
    return "".concat(path);
  } else {
    var _context;

    return _concatInstanceProperty(_context = "".concat(path, "/")).call(_context, name).replace(/\/+/gi, '/');
  }
};

export default function createReactRoutes(routes) {
  return function () {
    var _useRouteMatch = useRouteMatch(),
        path = _useRouteMatch.path;

    var routeslist = useMemo(function () {
      var _context2;

      return _mapInstanceProperty(_context2 = _Object$entries(routes)).call(_context2, function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            component = _ref2[1];

        return React.createElement(Route, {
          key: genFullPath(path, name),
          path: genFullPath(path, name),
          component: component,
          exact: name === 'index' || name[0] === '/'
        });
      });
    }, [path]);
    return React.createElement(Switch, null, routeslist, React.createElement(Route, {
      path: "*",
      component: function component() {
        throw new Error('NOT FOUND');
      }
    }));
  };
}